import { Box, Typography, Backdrop, CircularProgress } from '@mui/material';
import Header from './Header';
import PageMessage from './PageMessage';
import { useDispatch, useSelector } from 'react-redux';
import { appConfigs, appRoutes, oktaConfigs } from '../constants/ApplicationConstants';
import { useNavigate } from 'react-router-dom';
import { useOktaAuth } from '@okta/okta-react';
import { setPageMessage } from '../store/ApplicationStore';
import { updateMuiThme } from '../store/AuthStore';
import { createMuiTheme } from '../utils/AppUtils';

export default function PageLayout({ header, footer, children, backgroundImage, nogutter }){
    const { user, theme, muiTheme } = useSelector(state=> state.user)
    const { processing, pageMessage } = useSelector(state=> state.app)
    const { oktaAuth } = useOktaAuth();

    const navigate= useNavigate();
    const dispatch = useDispatch();

    async function handleLogout(){
        dispatch({type: 'LOGOUT'});
        await oktaAuth.signOut({ postLogoutRedirectUri: window.location.origin + oktaConfigs.oktaLogoutURL });
    };

    function handleNavigateToHome(){
        navigate(appRoutes.menu);
    }

    function handlePageMessageClose(){
        dispatch(setPageMessage(null))
    }

    function handleNavigateToPanel(){
        if(user)
        {
            if(user.role_id === 2){
                navigate(appRoutes.adminPanel);
            }else{
                navigate(appRoutes.insights);
            }
        }
    }

    function handleColorMode(mode, passedTheme){
        dispatch(updateMuiThme(createMuiTheme(mode, passedTheme)));
    }

    return(
        <>
            <Box style={!nogutter?{paddingLeft: '2rem', paddingRight: '2rem'}:null} sx={backgroundImage ? { display: 'flex', flexDirection: 'column', minHeight: '100vh', backgroundImage: `url(${backgroundImage})`, backgroundSize: 'cover', backgroundPosition: 'center'} : {display: 'flex', flexDirection: 'column', minHeight: '100vh'}}>
                {header&& <Header user={user} onLogout={handleLogout} navigateToHome={()=>{handleNavigateToHome()}} navigateToPanel={()=>{handleNavigateToPanel()}} handleColorMode={handleColorMode} theme={theme} muiTheme= {muiTheme} /> }
                <Box  sx={{ flexGrow: 1, mt: '5rem', height:'100%', width: '100%' }}>
                    {children}
                </Box>
                {footer&& <footer>
                    <Typography sx={{px: '2rem',paddingBottom:'10px'}} variant="subtitle2" style={{float: 'right'}} fontSize={'10px'}>{appConfigs.footerText}</Typography>
                </footer>}
            </Box>
            <Backdrop sx={{ color: '#fff', zIndex: 2000}} open={processing}>
                <CircularProgress color="inherit" />
            </Backdrop>
            {pageMessage&&<PageMessage show={pageMessage?true:false} message={pageMessage.message} type={pageMessage.type} clearPageMessage={handlePageMessageClose}/>}
        </>
    )
}